import { onLoad } from 'runtime';
import { SearchableVehicleDropdown, VehicleSelectionState, formatFuelVersionOption, formatModelYearOption } from './vehicle-selection-core.js?v=6';

onLoad(context => {
    context.querySelectorAll('[data-vehicle-selection]').forEach(root => {
        if (root.vehicleSelection) return;
        root.vehicleSelection = true;
        const status = root.querySelector('[data-vehicle-status]');
        const retry = root.querySelector('[data-vehicle-retry]');
        const submit = root.querySelector('[data-vehicle-submit]');
        const announce = text => { status.textContent = text; };
        const load = async (type, id) => {
            const url = type === 'models' ? root.dataset.modelYearsUrl : root.dataset.fuelVersionsUrl;
            const response = await window.fetch(url.replace(/\/0$/, '/' + encodeURIComponent(id)), {
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
            });
            if (!response.ok) throw new Error('Unable to load vehicles');
            const data = await response.json();
            if (!Array.isArray(data)) throw new Error('Invalid vehicle response');
            return data.map(type === 'versions' ? formatFuelVersionOption : formatModelYearOption);
        };
        const sync = () => {
            root.querySelectorAll('[data-vehicle-id]').forEach(input => { input.value = state.ids[input.dataset.vehicleId] || ''; });
            submit.disabled = !state.ids.versionId;
        };
        const state = new VehicleSelectionState(load, (event, options) => {
            retry.hidden = true;
            announce('');
            if (event === 'clear-models') model.setOptions([], 'Choose manufacturer first', true);
            if (event === 'clear-models' || event === 'clear-versions') version.setOptions([], 'Choose model and year first', true);
            if (event === 'loading-models') model.setOptions([], 'Loading models and years…', true);
            if (event === 'loading-versions') version.setOptions([], 'Loading fuels and versions…', true);
            if (event === 'models') model.setOptions(options, options.length ? 'Choose model and year' : 'No models available', !options.length);
            if (event === 'versions') version.setOptions(options, options.length ? 'Choose fuel and version' : 'No versions available', !options.length);
            if (event.startsWith('loading-')) announce('Loading vehicles…');
            if (options) announce(options.length ? `${options.length} ${event === 'models' ? 'model and year' : 'fuel and version'} choices available.` : 'No vehicles available for this selection. Please choose another option.');
            if (event.startsWith('error-')) {
                if (event === 'error-models') model.setOptions([], 'Unable to load — retry below', true);
                else version.setOptions([], 'Unable to load — retry below', true);
                announce('Unable to load vehicles. Please retry.');
                retry.hidden = false;
                retry.onclick = () => event === 'error-models' ? state.manufacturer(manufacturer.value) : state.modelYear(model.value);
            }
            root.setAttribute('aria-busy', String(event.startsWith('loading-')));
            sync();
        });
        const manufacturer = new SearchableVehicleDropdown(root.querySelector('[data-vehicle-manufacturer]'), option => state.manufacturer(option), announce);
        const model = new SearchableVehicleDropdown(root.querySelector('[data-vehicle-model-year]'), option => state.modelYear(option), announce);
        const version = new SearchableVehicleDropdown(root.querySelector('[data-vehicle-fuel-version]'), option => state.version(option), announce);
        // The desktop sidebar can sit inside the category's unrelated filter form.
        const form = root.closest('[data-vehicle-sidebar]') ? null : root.closest('form');
        if (form) form.addEventListener('submit', e => {
            if (!state.ids.versionId) {
                e.preventDefault();
                e.stopImmediatePropagation();
                announce('Please choose a vehicle from all three dropdowns.');
            }
        }, true);
        submit.addEventListener('click', () => {
            if (!state.ids.versionId) return;
            if (form) form.requestSubmit();
            else root.dispatchEvent(new CustomEvent('modelSearch', { bubbles: true, detail: { ...state.ids, selector: root } }));
        });
    });
});
